import React, { Component } from 'react'
import PropTypes from 'prop-types'

import omit from 'lodash/omit'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GlobalMessageContainer'

    static propTypes = {
      autoCloseAfter: PropTypes.number,
      dismiss: PropTypes.func.isRequired,
      error: PropTypes.bool,
      header: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      positive: PropTypes.bool,
      warning: PropTypes.bool,
    }

    static defaultProps = {
      autoCloseAfter: -1,
      error: false,
      positive: false,
      warning: false,
    }

    state = {
      className: 'fadeIn',
      timeout: null,
    }

    componentDidMount() {
      const { autoCloseAfter } = this.props

      if (autoCloseAfter > -1) {
        this.setState({
          timeout: setTimeout(this.handleDismiss, autoCloseAfter),
        })
      }
    }

    componentWillUnmount() {
      const { timeout } = this.state

      if (timeout) {
        clearTimeout(timeout)
      }
    }

    handleDismiss = () => {
      const { dismiss } = this.props
      const { timeout } = this.state

      if (timeout) {
        clearTimeout(timeout)
      }

      this.setState({ className: 'fadeOut' }, () => setTimeout(dismiss, 500))
    }

    render() {
      return (
        <WrappedComponent className={this.state.className} handleDismiss={this.handleDismiss} {...omit(this.props, ['autoCloseAfter'])} />
      )
    }
  }

  return Container
}
